"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CommandKioskRouter = _interopRequireDefault(require("../shared/CommandKioskRouter"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ModernCommandCell = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandKioskRouter.default, {
  templateVariant: "modern",
  ...props
});
var _default = exports.default = ModernCommandCell;